export const errorMessages = <const>{
  ageMax85: 'Maximum age we can lend to is up to the age of 85 (unless on the RIO product)',
  ageMin18: 'Minimum age we can lend to is 18 for residential applications',
  ageMin21: 'Minimum age we can lend to is 21 for buy to let applications',
  ageRange: 'You must be between 55 and 90 years old',
  employedMin1Mo: 'At least 1 months pay shown in bank account and no probation',
  grossAnnualOver20k: 'LGHF has a minimum income requirement of £20,000 after deductions',
  htb: 'LGHF does not accept \'Help to Buy Equity Loan\' applications',
  ioLessThanLoanAmount: 'Amount on interest only must be less than loan amount',
  loanTermMax: '40 years maximum term',
  loanTermMin: '5 years minimum term',
  ltvPercentBtl: 'Max LTV is 80%',
  ltvPercentBtlFlat: 'Max LTV on flats is 80%',
  ltvPercentBtlHmo: 'Max LTV for HMO is 75%',
  ltvPercentBtlMultiUnit: 'Max LTV for Multi unit is 75%',
  ltvPercentBtlNewBuild: 'Max LTV on new build is 80%',
  ltvPercentBtlL4LRemortgage: 'Max LTV for like for like re-mortgage is 80%',
  ltvPercentResi: 'Loan amount should not exceed 100% of property value',
  minLoanSize: 'Minimum loan size, £10,000',
  noExpatApplicants: 'LGHF does not accept expat buy to let business',
  noFirstTimeBuyer: 'LGHF does not accept Buy to Let applications from \'First Time Buyers\'',
  onlyOwnerOccupiers: 'LGHF does not accept Buy to Let applications from \'Non Owner Occupiers\'',
  repaymentIoEquityMin100000: 'LGHF has a minimum equity requirement for interest only lending of £100,000',
  selfemployedMin2Yr: '3 years normally, but we can consider 2 years if the income is consistent over the 2 years',
  lowPropertyValueFlat: 'Property value must be over £100,000',
  lowPropertyValueHouse: 'Property value must be over £70,000',
  lowPropertyValueHouseGap: 'Property value must be over £100,000',
  maxPropertyValue: 'Maximum property value is £4,000,000',
  maxltv: 'The desired amount is larger than our 60% LTV but we could consider up £{{maxLtv}}',
  required: 'The field is required',
};
